/**
 * Module: Card Swiper Slider
 * Description: Inizializza gli slider card per sezioni Attivita e News.
 */

export function initCardSlider() {
	if (typeof Swiper === "undefined") {
		console.warn("Swiper non disponibile per gli slider card.");
		return;
	}

	const sliders = document.querySelectorAll(".swiper-card-slider");

	if (!sliders.length) {
		return;
	}

	sliders.forEach((slider) => {
		const section = slider.closest(".s-attivita-section");
		const slidesCount = slider.querySelectorAll(".swiper-slide").length;

		if (!section || !slidesCount || slider.dataset.swiperInitialized === "true") {
			return;
		}

		const prevEl = section.querySelector(".s-attivita-section__slider-btn--prev");
		const nextEl = section.querySelector(".s-attivita-section__slider-btn--next");
		const paginationEl = section.querySelector(".s-attivita-section__slider-pagination");

		new Swiper(slider, {
			slidesPerView: 1,
			spaceBetween: 24,
			loop: false,
			watchOverflow: true,
			autoplay: false,
			navigation: {
				prevEl,
				nextEl,
			},
			pagination: {
				el: paginationEl,
				clickable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 24,
				},
				1200: {
					slidesPerView: 3,
					spaceBetween: 24,
				},
			},
		});

		slider.dataset.swiperInitialized = "true";
	});
}
